__turbopack_context__.v({
  "background": "style-module-scss-module__2Lgv8a__background",
  "content": "style-module-scss-module__2Lgv8a__content",
  "description": "style-module-scss-module__2Lgv8a__description",
  "error": "style-module-scss-module__2Lgv8a__error",
  "field": "style-module-scss-module__2Lgv8a__field",
  "fieldsWrap": "style-module-scss-module__2Lgv8a__fieldsWrap",
  "footerBottom": "style-module-scss-module__2Lgv8a__footerBottom",
  "footerDescription": "style-module-scss-module__2Lgv8a__footerDescription",
  "form": "style-module-scss-module__2Lgv8a__form",
  "formFieldset": "style-module-scss-module__2Lgv8a__formFieldset",
  "fullWidthField": "style-module-scss-module__2Lgv8a__fullWidthField",
  "grayscaleVideo": "style-module-scss-module__2Lgv8a__grayscaleVideo",
  "hidden": "style-module-scss-module__2Lgv8a__hidden",
  "submitButton": "style-module-scss-module__2Lgv8a__submitButton",
  "submitButtonWrapper": "style-module-scss-module__2Lgv8a__submitButtonWrapper",
  "title": "style-module-scss-module__2Lgv8a__title",
  "video": "style-module-scss-module__2Lgv8a__video",
  "videoWrapper": "style-module-scss-module__2Lgv8a__videoWrapper",
  "wrapper": "style-module-scss-module__2Lgv8a__wrapper",
});
